(function() {
    'use strict';

    angular.module('ksef')
        .controller('KsefCompanyDetailController', KsefCompanyDetailController);

    KsefCompanyDetailController.$inject = [
        '$state',
        'notificationSrvc',
        'errorNotificationSrvc',
        'checkModelPermissionsSrvc',
        'datatableDefaultPageSizeValueConst',
        'filterQuerySrvc',
        'lodashService',
        'ksefCompanyDataSrvc',
        'ksefCompanyPermissionsConst',
        'ksefCompanyMessagesConst',
        'ksefCertificateMessagesConst',
        'ksefCertificatePermissionsConst',
        'ksefCertificateSrvc'
    ];

    function KsefCompanyDetailController(
        $state,
        notificationSrvc,
        errorNotificationSrvc,
        checkModelPermissionsSrvc,
        datatableDefaultPageSizeValueConst,
        filterQuerySrvc,
        lodashService,
        ksefCompanyDataSrvc,
        ksefCompanyPermissionsConst,
        ksefCompanyMessagesConst,
        ksefCertificateMessagesConst,
        ksefCertificatePermissionsConst,
        ksefCertificateSrvc
    ) {
        var self = this;

        self.loading = false;
        self.activatingConnection = false;

        self.companyData = {};

        self.loadingCerts = false;
        self.certsRows = [];
        self.certsCols = [{
            title: 'Nazwa',
            value: 'label',
            type: 'text',
            searchable: false,
            orderable: false
        },
        {
            title: 'Aktywny',
            value: 'is_active',
            type: 'boolean',
            searchable: false,
            orderable: false
        },
        {
            title: 'Ważny do',
            value: 'valid_until',
            type: 'text',
            searchable: false,
            orderable: true
        },
        {
            title: 'Numer seryjny',
            value: 'serial_number',
            type: 'text',
            searchable: false,
            orderable: false
        },
        {
            title: 'Nazwa podmiotu',
            value: 'subject_cn',
            type: 'text',
            searchable: false,
            orderable: false
        },
        {
            title: 'Data dodania',
            value: 'date_added',
            searchable: false,
            orderable: true,
        },
        {
            title: 'Utworzono przez',
            value: 'created_by',
            searchable: false,
            orderable: false,
        }];
        self.certificateModelPermissions = ksefCertificatePermissionsConst;
        self.pageOptsCerts = {
            count: 0,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };
        self.searchQueryCerts = {
            ordering: null
        };

        self.certPageChange = certPageChange;
        self.onCertSearchQueryChange = onCertSearchQueryChange;

        self.hasActiveCertificate = hasActiveCertificate;
        self.activateConnection = activateConnection;
        self.isConnectionActive = isConnectionActive;
        self.onCertCreate = onCertCreate;
        self.onCertDelete = onCertDelete;
        self.goToEdit = goToEdit;

        self.hasCompanyUpdatePerm = hasCompanyUpdatePerm;

        activate();

        function activate() {
            self.pageOptsCerts = filterQuerySrvc.initializePageOpts(self.pageOptsCerts);
            self.searchQueryCerts = filterQuerySrvc.initializeSearchQuery(self.searchQueryCerts);
            filterQuerySrvc.setLocationParams();

            getCompany();
            getCompanyCerts();
        }

        function getCompany() {
            self.loading = true;

            return ksefCompanyDataSrvc.get({
                pk: $state.params.pk
            }).$promise.then(function(response) {
                self.companyData = response;
                return response;
            }).finally(function() {
                self.loading = false;
            });
        }

        function getCompanyCerts(filterObj) {
            self.loadingCerts = true;

            if (!filterObj) {
                filterObj = {
                    pk: $state.params.pk,
                    page: self.pageOptsCerts.page,
                    page_size: self.pageOptsCerts.pageSize,
                    ordering: self.searchQueryCerts.ordering
                };
            }

            return ksefCompanyDataSrvc.getCerts(
                filterObj
            ).$promise.then(function(response) {
                self.certsRows = response.results;
                self.pageOptsCerts.count = response.count;
                return response;
            }).finally(function() {
                self.loadingCerts = false;
            });
        }

        function activateConnection() {
            if (!hasCompanyUpdatePerm()) {
                return;
            }

            self.activatingConnection = true;

            return ksefCompanyDataSrvc.activateConnection({
                pk: self.companyData.pk
            }).$promise.then(
                function(response) {
                    self.companyData = response;
                    notificationSrvc.notification('success', ksefCompanyMessagesConst.activationSuccess);
                    return response;
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    notificationSrvc.notification('error', ksefCompanyMessagesConst.activationError);
                    return response;
                }
            ).finally(function() {
                self.activatingConnection = false;
            });
        }

        function hasActiveCertificate(){
            return self.companyData.active_certificate !== null;
        }

        function isConnectionActive(){
            return self.companyData.is_connected;
        }

        function onCertCreate(){
            $state.go('layout.ksef-companies.create-company-cert', { pk: self.companyData.pk });
        }

        function onCertDelete(row) {
            var title = row.label + " (" + row.serial_number + ")";
            return ksefCertificateSrvc.remove(title, row.pk, function(response) {
                notificationSrvc.notification("success", ksefCertificateMessagesConst.delete);
                lodashService.remove(self.certsRows, { pk: row.pk });
                return response;
            }, function (response){
                errorNotificationSrvc.displayErrors(response.data);
                return response;
            });
        }

        function goToEdit() {
            $state.go('layout.ksef-companies.update', { pk: self.companyData.pk });
        }

        function certPageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOptsCerts);
            filterQuerySrvc.setLocationParams();
            return getCompanyCerts();
        }

        function onCertSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQueryCerts);
            filterQuerySrvc.setLocationParams();
            return getCompanyCerts();
        }

        function hasCompanyUpdatePerm() {
            return !checkModelPermissionsSrvc.isDenied(ksefCompanyPermissionsConst.update);
        }
    }
})();
